//**auto-generated don't edit this code**//
export enum UserType {
	V,
	T,
	C,
	D,
	S,
	M,
	A,
	ISS,
	ISD,
	PA,
	Student,
}